import React from "react";
import { Trans } from 'react-i18next';

import VehiclesListRow from './VehiclesListRow_DEPRECATED';
import { LoadingIconRow } from '../../../../Common/Loading_Icon';

export const VehiclesList = ({ vehicles, loading, history, match, location, sortBy, sortOrder, updateSorting }) => {
	const addSortClasses = (sortTerm) =>
		sortBy === sortTerm
			? sortOrder === "asc"
				? "fa-sort-up primary"
				: "fa-sort-down primary"
			: "fa-sort";

	return (
		<div className="table-wrapper">
			<table>
				<thead>
					<tr>
						<th
							className={sortBy === 'vehicle' ? 'is-sorted' : 'th'}
							onClick={() => updateSorting('vehicle')}
						>
							<Trans>Vehicle</Trans>
							<i className={`sort-icon fas black-lightest ${addSortClasses('vehicle')}`}></i>
						</th>
						<th className="th-center">
							<Trans>Status</Trans> <i className="sort-icon fas black-lightest"></i>
						</th>
						<th className="th-center">
							<div className="th-wrapper" style={{width:'60px'}}>
								<div className="th-text float-left">
									<Trans>Booking<br />Activity</Trans>
								</div>
								<i className="sort-icon fas black-lightest float-left"></i>
								<div className="clearfix"></div>
							</div>
							<i className="fas fa-info-circle black-lighter" data-tip="Active Vehicles have been booked in the last 90 days. Inactive Vehicles haven't been booked in the last 90 days."></i>
						</th>
						<th className="not-sortable th-center">
							<Trans>Department</Trans>
						</th>
						<th className="not-sortable th-center">
							<Trans>Vehicle Centre</Trans>
						</th>
						<th className="th-center">
							<Trans>Tier</Trans> <i className="sort-icon fas black-lightest"></i>
						</th>
						<th className="th-center">
							<span style={{paddingRight: '0px'}}>
								<Trans>Utilization</Trans><i className="sort-icon fas black-lightest"></i>
							</span>
							<i className="fas fa-info-circle black-lighter ml-8" data-tip="Utilization rate of the vehicle in the last 3 months" onClick={null}></i>
						</th>
						<th className="th-center"><Trans>Mileage</Trans><i className="sort-icon fas black-lightest"></i></th>
						<th className="th-center">
							<span style={{paddingRight: '0px'}}>
								<Trans>Bookings</Trans><i className="sort-icon fas black-lightest"></i>
							</span>
							<i className="fas fa-info-circle black-lighter ml-8" data-tip="Number of bookings in the last 3 months" onClick={null}></i>
						</th>
						<th className="double-line th-center">
							<div className="th-wrapper" style={{width:'60px'}}>
								<div className="th-text float-left">
									<Trans>Last<br />Booking</Trans>
								</div>
								<i className="sort-icon fas black-lightest float-left"></i>
								<div className="clearfix"></div>
							</div>
						</th>
						<th className="not-sortable">
							<Trans>Actions</Trans>
						</th>
					</tr>
				</thead>
				<tbody>
					{vehicles?.map((vehicle, i) => (
						<VehiclesListRow vehicle={vehicle} key={'user_row-' + vehicle.V_ID} history={history} match={match} location={location}/>
					))}

					{loading && (
						LoadingIconRow(11)
					)}
				</tbody>
			</table>
		</div>
	)
}